'use client';

import { Divider, MenuItem, Select, styled } from '@mui/material';
import { Icon } from '@/components';

const SearchSelect = styled(Select)(({ theme }) => ({
  background: 'transparent',
  '&:before': {
    border: 'none!important',
  },
  '&:after': {
    border: 'none!important',
  },
  '& .MuiSelect-select': {
    border: 'none',
    fontWeight: 700,
    paddingRight: '8px!important',
    '&:focus': {
      background: 'transparent',
    },
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    paddingRight: '4px!important',
    '& .MuiSelect-select': {
      paddingRight: '4px!important',
    },
  },
}));

const SearchGroup = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isFocused'
})<{ isFocused: boolean }>(({ theme, isFocused }) => ({
  display: 'flex',
  alignItems: 'center',
  transition: 'all 0.15s ease-out',
  [theme.breakpoints.down('sm')]: {
    position: 'relative',
    transform: `translateX(${isFocused ? '-15px' : '0'})`,
    opacity: isFocused ? 0 : 1,
    maxWidth: isFocused ? 0 : '100px',
    margin: isFocused ? 0 : undefined,
    pointerEvents: isFocused ? 'none' : 'auto',
    '& > *': {
      transition: 'all 0.15s ease-out',
    }
  }
}));

interface SearchTypeProps {
  isFocused: boolean;
  options: Array<{ label: string; value: number }>;
}

export const SearchType = ({ isFocused, options }: SearchTypeProps) => {
  return (
    <SearchGroup isFocused={isFocused}>
      <SearchSelect
        defaultValue={options[0]?.value || 10}
        variant="standard"
        IconComponent={() => <Icon.ArrowDown sx={{ fontSize: { md: '1rem', xs: '0.75rem' }, color: "primary.main" }}/>}
        MenuProps={{ disableScrollLock: true }}
        labelId="type-product"
        id="type-product"
        displayEmpty
      >
        {options.map((item) => (
          <MenuItem sx={{ fontSize: { md: '16px', xs: '14px' } }} key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </SearchSelect>
      <Divider 
        sx={{ 
          height: 16, 
          m: { md: '12px', xs: '6px' },
        }} 
        orientation="vertical" 
      />
    </SearchGroup>
  );
};